module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity11.e9c38efd.jpg";